module.exports = __webpack_public_path__ + "images/header/saubere_filme_header_foto.jpg";